import type { Navbar } from "../services/user";

export type WorkspaceSidebar = {
  links: {
    url: string;
    label: string;
    icon?: string;
    key?: string;
  }[];
  signout: string;
  services: {
    url: string;
    label: string;
    entrypoint: string;
  }[];
  administration: string;
};

export function getWorkspaceSidebar(navbar: Navbar): WorkspaceSidebar {
  return {
    signout: navbar.footerMenu.logoutUrl,
    administration: navbar.footerMenu.adminUrl,
    links: navbar.footerMenu.pages.map((page) => ({
      url: page.url,
      label: page.label,
      icon: page.iconSrc || "",
      key: page.key,
    })),
    services: navbar.sections.map((section) => ({
      url: section.pageUrl,
      label: section.label,
      icon: section.iconSrc || "",
      entrypoint: section.entrypoint,
    })),
  };
}
